// store
import { useGl } from '@store/ts/gl';

export default function (props, context) {
    // store
    const gl = useGl();

    return {
        gl,
    };
}